import { Container, Text, Title } from '@mantine/core';
export function Placeholder({ title, body }: { title: string; body?: string }) {
  return (
    <Container size={640} py="lg">
      <Title order={2}>{title}</Title>
      <Text c="dimmed" mt="sm">
        {body ?? 'Coming in a later milestone.'}
      </Text>
    </Container>
  );
}
